import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  Renderer2,
  SimpleChanges
} from '@angular/core';

declare let delta: any;

@Directive({
  selector: '[ngc-scroll-directive]',
  exportAs: 'ngcScrollDirective'
})
export class ScrollDirective implements OnChanges {
  lastScrollTop = 0;
  eleTopMargin = 75;
  direction = '';
  @Input()
  childLabel: string;
  @Input()
  viewInitialised = false;
  @Input()
  widgetOffset: number;

  @Output()
  clickedOutside = new EventEmitter<boolean>();
  @Output()
  reachedTop = new EventEmitter<boolean>();
  @Output()
  widgetCrossed = new EventEmitter<boolean>();

  scrollCrossedWidget: boolean;
  widgetHeight = 0;

  constructor(private el: ElementRef, private rend: Renderer2) {}

  @HostListener('window:scroll', ['$event']) onWindowScroll(event) {
    if (window.innerWidth <= 991) {
      return;
    }
    const st = window.pageYOffset;
    if (st > this.lastScrollTop) {
      this.direction = 'down';
    } else {
      this.direction = 'up';
    }
    this.lastScrollTop = st;

    if (
      this.el.nativeElement.offsetHeight + this.widgetOffset <
      this.lastScrollTop
    ) {
      this.scrollCrossedWidget = true;
      this.widgetCrossed.emit(true);
    } else {
      this.scrollCrossedWidget = false;
      this.widgetCrossed.emit(true);
    }
    if (this.lastScrollTop < this.el.nativeElement.offsetHeight) {
      this.reachedTop.emit();
    }
  }

  @HostListener('document:click', ['$event']) onclick(event) {
    if (window.innerWidth <= 991) {
      return;
    }
    const clickedInside = this.el.nativeElement.contains(event.target);
    let clickedInsideModal = false;
    const shouldAvoid =
      event &&
      event.target.classList &&
      (event.target.classList.contains('external-widget-trigger') ||
        event.target.classList.contains('calenderContainer') ||
        event.target.classList.contains('donebutton') ||
        event.target.classList.contains('dl-state-default') ||
        event.target.classList.contains('closeButton') ||
        event.target.classList.contains('doneButton') ||
        event.target.classList.contains('app-link') ||
        event.target.classList.contains('remove-flight') ||
        event.target.classList.contains('add-flight'))
        ? true
        : false;

    if (document && document.body && document.body.classList) {
      clickedInsideModal = document.body.classList.contains('modal-open');
    }
    this.clickedOutside.emit(
      !clickedInside && !clickedInsideModal && !shouldAvoid
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.viewInitialised || changes.childLabel || changes.widgetOffset) {
      this.widgetHeight = this.el.nativeElement.offsetHeight;
    }
  }
}
